export default {
  namespaced: true,
  state: () => ({
    title: null,
    showLogo: false,
    backUrl: null,
    goDelta: -1,

    setTitleIntervalId: null,

    // 03
    isMainMenuShrink: false, // pc
    showMainMenuSlideModal: false, // mobile
    showMainMenu: true,

    // 12
    switchMainMenuShrink: true,

    // 12, 14, 15, 16, 18
    switchBtnModal: 'game',

    // 12, 14, 15
    showMenuSwitchLocaleContent: false
  }),
  actions: {
    back({ state, commit }) {
      if (
        ['01', '02'].includes(process.env.TEMPLATE_ID) &&
        ($nuxt.$route.path.indexOf('/slot') !== -1 ||
          $nuxt.$route.path.indexOf('/real-person-video') !== -1 ||
          $nuxt.$route.path.indexOf('/sport') !== -1 ||
          $nuxt.$route.path.indexOf('/lottery-ticket') !== -1 ||
          $nuxt.$route.path.indexOf('/chess') !== -1 ||
          $nuxt.$route.path.indexOf('/fish') !== -1 ||
          $nuxt.$route.path.indexOf('/m-auth/login') !== -1 ||
          $nuxt.$route.path.indexOf('/m-auth/sign-up') !== -1 ||
          $nuxt.$route.path.indexOf('/m-forgot-password/sms') !== -1 ||
          $nuxt.$route.path.indexOf('/m-forgot-password/email') !== -1)
      ) {
        return $nuxt.$router.push('/')
      }
      if (state.backUrl !== null) {
        $nuxt.$router.push(state.backUrl)
        commit('BACK_URL', null)
        return
      }
      const goDelta = state.goDelta
      if (state.goDelta !== -1) {
        commit('GO_DELTA', -1)
      }
      $nuxt.$router.go(goDelta)
    }
  },
  mutations: {
    TITLE(state, payload) {
      state.title = payload
    },
    SHOW_LOGO(state, payload) {
      state.showLogo = payload
    },
    BACK_URL(state, payload) {
      state.backUrl = payload
    },
    GO_DELTA(state, payload) {
      state.goDelta = payload
    },
    SET_TITLE_INTERVAL_ID(state, payload) {
      state.setTitleIntervalId = payload
    },

    IS_MAIN_MENU_SHRINK(state, payload) {
      state.isMainMenuShrink = payload
    },
    SHOW_MAIN_MENU_SLIDE_MODAL(state, payload) {
      state.showMainMenuSlideModal = payload
    },
    SHOW_MAIN_MENU(state, payload) {
      state.showMainMenu = payload
    },
    SHOW_MENU_SWITCH_LOCALE_CONTENT(state, payload) {
      state.showMenuSwitchLocaleContent = payload
    },
    SWITCH_BTN_MODAL(state, payload) {
      state.switchBtnModal = payload
    },
    SWITCH_MAIN_MENU_SHRINK(state, payload) {
      state.switchMainMenuShrink = payload
    }
  },
  getters: {
    title: state => state.title,
    showLogo: state => state.showLogo,
    backUrl: state => state.backUrl,
    goDelta: state => state.goDelta,
    setTitleIntervalId: state => state.setTitleIntervalId,

    isMainMenuShrink: state => state.isMainMenuShrink,
    showMainMenuSlideModal: state => state.showMainMenuSlideModal,
    showMainMenu: state => state.showMainMenu,
    showMenuSwitchLocaleContent: state => state.showMenuSwitchLocaleContent,
    switchBtnModal: state => state.switchBtnModal,
    switchMainMenuShrink: state => state.switchMainMenuShrink
  }
}
